<template lang="pug">
  v-container.fill-height
    v-row(no-gutters)
      v-col(cols="12" align="center" justify="center")
        v-card(max-width="400" v-if="!setPassword")
          div.pt-4
            v-img(:src="require('@/assets/arba_logo_small.png')" contain height="40")
          div.text-center.mt-4
            h1 Tour Guide App
          v-card-text
            v-row
              v-col(cols="12")
                v-text-field(v-model="username" label="Username" @keyup.enter="login")
              v-col(cols="12")
                v-text-field(v-model="password" label="Password" type="password" @keyup.enter="login")
          v-card-actions
            v-btn.primary(block depressed @click="login" :loading="loading") Login
        v-card(max-width="400" v-else)
          v-card-title.text-center.ml-2 Set new password
          v-card-text
              v-col(cols="12")
                v-text-field(v-model="new_password" label="New Password" type="password" @keyup.enter="changePassword")
              v-col(cols="12")
                v-text-field(v-model="confirm_password" label="Confirm New Password" type="password" @keyup.enter="changePassword")
          v-card-actions
            v-btn.primary(block depressed @click="changePassword" :loading="loading") Set Password

</template>

<script>
export default {
  name: 'Login',
  data: () => ({
    username: '',
    password: '',
    new_password: '',
    confirm_password: '',
    loading: false,
    setPassword: false
  }),
  methods: {
    login () {
      if (!this.username) {
        this.$store.dispatch('showSnackbar', { message: 'Fill in username', color: 'error' })
        return
      }

      if (!this.password) {
        this.$store.dispatch('showSnackbar', { message: 'Fill in password', color: 'error' })
        return
      }

      const data = {
        username: this.username,
        password: this.password
      }
      this.loading = true
      this.$axios.post('/login/', data)
        .then(resp => {
          this.$store.commit('setUser', resp.data)
          this.$store.dispatch('showSnackbar', { message: 'Login success', color: 'success' })
          if (!resp.data.password_changed) {
            this.setPassword = true
          } else {
            this.$router.push('/')
          }
        })
        .catch(e => {
          this.$store.dispatch('showSnackbar', { message: e.response.data[0], color: 'error' })
        })
        .finally(() => {
          this.loading = false
        })
    },
    changePassword () {
      if (!this.new_password) {
        this.$store.dispatch('showSnackbar', { message: 'Fill in new password', color: 'error' })
        return
      }

      if (!this.confirm_password) {
        this.$store.dispatch('showSnackbar', { message: 'Fill in confirm password', color: 'error' })
        return
      }

      if (this.new_password !== this.confirm_password) {
        this.$store.dispatch('showSnackbar', { message: 'Password does not match', color: 'error' })
        return
      }

      const data = {
        username: this.username,
        new_password: this.new_password
      }
      this.loading = true
      this.$axios.post('/set_password/', data)
        .then(resp => {
          const user = this.$store.state.user
          user.password_changed = true
          this.$store.commit('setUser', user)
          this.$store.dispatch('showSnackbar', { message: 'New password set', color: 'success' })
          this.$router.push('/')
        })
        .catch(e => {
          console.log(e)
          this.$store.dispatch('showSnackbar', { message: 'Error setting new password. Please contact ARBA Travel representative.', color: 'error' })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>

</style>